import { gql } from '@apollo/client';

export const fetchInternalLicensesTotalCount = gql`
  query fetchInternalLicensesTotalCount(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $relatedDomains: [String]!
  ) {
    transactionAccount(id: $id) {
      id
      internalUseSubscriptions(
        searchOptions: $searchOptions
        filterOptions: $filterOptions
        relatedDomains: $relatedDomains
      ) {
        totalCount
      }
    }
  }
`;
